<nz-layout>
    <nz-header class="application__header">
        <a (click)="navigateToUpload()" style="cursor: pointer" class="application__header__title"><b>PIDB</b> Code Recommender</a>
        <div nz-dropdown
             [nzDropdownMenu]="profileMenu">
            <span style="color: #ffffff; padding-right: 10px">Hello, {{getStringUpToLastSpace(username)}}</span>
            <nz-avatar [nzText]="username.substring(0, 2).toUpperCase()"
                       class="header-profile">

            </nz-avatar>
            <span class="drop-down-icon" nz-icon nzType="down" nzTheme="outline"></span>
        </div>
        <nz-dropdown-menu #profileMenu="nzDropdownMenu">
            <ul nz-menu nzSelectable style="width: auto; padding: 10px;">
<!--                <li>-->
<!--                    <nz-avatar style="margin: 0 10px" [nzText]="username.substring(0, 2).toUpperCase()"-->
<!--                               class="drop-down-profile"></nz-avatar>-->
<!--                    <span> {{username}}</span>-->
<!--                </li>-->
                <li *ngxPermissionsOnly="[userRole.admin]" nz-menu-item class="sign-out-button account-menu" (click)="goToPage('home/users-settings/users-list')"><span nz-icon nzType="user" nzTheme="outline"></span>Manage users</li>
                <li *ngxPermissionsOnly="[userRole.admin]" nz-menu-item class="sign-out-button account-menu" (click)="goToPage('home/advanced-settings')"><span nz-icon nzType="code" nzTheme="outline"></span>Manage PIDB codes</li>
                <li nz-menu-item class="sign-out-button account-menu" (click)="goToPage('/home/file-upload')"><span nz-icon nzType="upload" nzTheme="outline"></span>Upload file</li>
                <li nz-menu-item class="sign-out-button account-menu" (click)="signOut()"><span nz-icon nzType="logout" nzTheme="outline"></span>Sign out</li>
            </ul>
        </nz-dropdown-menu>
    </nz-header>
    <nz-content class="application__content">
        <div class="content-body">
            <router-outlet></router-outlet>
        </div>
<!--        <div class="footer">-->
<!--            Powered by-->
<!--            <img class="footer-logo" src="assets/inmind.ai-logo.png">-->
<!--        </div>-->
    </nz-content>
</nz-layout>
